<template>
  <v-icon
    :title="trans('booking.isOnlyCanceledInStayin')"
    color="warning"
    class="pr-1"
  >mdi-alert</v-icon>
</template>

<script>
import {LocaleUtils} from '../../utils/locale-utils.js';

export default {
  name: 'BookingOnlyCanceledInStayin',
  mixins: [
    LocaleUtils
  ]
}
</script>

<style scoped>

</style>
